import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSchedulesApiClient } from '../api/useSchedulesApiClient';
import { invalidateScheduleList } from './invalidate';

export function useCancelSchedule() {
  const client = useSchedulesApiClient();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (scheduleId: string) => client.cancelSchedule(scheduleId),
    onSuccess: () => {
      void invalidateScheduleList(queryClient);
    },
  });

  return {
    cancelSchedule: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
